import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { CopyIcon } from "lucide-react";
import { useState } from "react";

type Props = { value: string; className?: string; inputClassName?: string };

function CopyTextField({ value, className, inputClassName }: Props) {
  const copyStatusInitialValue = "Copy to clipboard";
  const copiedStatusValue = "Copied value!";
  const [copyStatusValue, setCopyStatusValue] = useState<string>(
    copyStatusInitialValue,
  );
  const [showTip, setShowTip] = useState(false);

  const resetTooltip = () => {
    setCopyStatusValue(copyStatusInitialValue);
    setShowTip(false);
  };

  return (
    <div
      className={cn(
        "bg-tertiary rounded-sm flex items-center gap-2",
        className,
      )}
    >
      <input
        readOnly
        value={value}
        className={cn(
          "flex-1 border-none bg-transparent! text-sm text-secondary-foreground shadow-none outline-none px-3",
          inputClassName,
        )}
      />

      <Tooltip open={showTip}>
        <TooltipTrigger asChild>
          <Button
            onClick={() => {
              navigator.clipboard.writeText(value);
              setCopyStatusValue(copiedStatusValue);
            }}
            onMouseEnter={() => setShowTip(true)}
            onMouseLeave={resetTooltip}
            className="bg-transparent text-secondary-foreground hover:text-primary-foreground"
          >
            <CopyIcon className="rotate-y-180 " />
          </Button>
        </TooltipTrigger>

        <TooltipContent>{copyStatusValue}</TooltipContent>
      </Tooltip>
    </div>
  );
}

export default CopyTextField;
